import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_3 = { class: "p-fluid" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-key" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VInputText = _resolveComponent("VInputText")!
  const _component_VDropdown = _resolveComponent("VDropdown")!
  const _component_VInputSwitch = _resolveComponent("VInputSwitch")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Password = _resolveComponent("Password")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!

  return (_openBlock(), _createElementBlock("form", {
    id: _ctx.formId,
    onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
  }, [
    _createVNode(_component_Fieldset, { class: "p-fluid" }, {
      legend: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_VInputText, { field: "id" }, null, 512), [
          [_vShow, false]
        ]),
        _createVNode(_component_VInputText, {
          label: _ctx.$t('user.name'),
          field: "name"
        }, null, 8, ["label"]),
        _createVNode(_component_VInputText, {
          label: _ctx.$t('user.surname'),
          field: "surname"
        }, null, 8, ["label"]),
        _createVNode(_component_VInputText, {
          label: _ctx.$t('user.email'),
          field: "email"
        }, null, 8, ["label"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_VDropdown, {
            id: "role-dropdown",
            modelValue: _ctx.value.role,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.value.role = $event)),
            label: _ctx.$t('user.role'),
            options: _ctx.roleOptions,
            autocomplete: "nope",
            name: "role"
          }, null, 8, ["modelValue", "label", "options"])
        ]),
        _createVNode(_component_VInputSwitch, {
          modelValue: _ctx.value.is_active,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value.is_active = $event)),
          labelOff: _ctx.$t('user.inactive'),
          labelOn: _ctx.$t('user.active') ,
          name: "is_active"
        }, null, 8, ["modelValue", "labelOff", "labelOn"])
      ]),
      _: 1
    }),
    _createVNode(_component_Fieldset, { class: "p-fluid p-mt-3" }, {
      legend: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('user.password') + ' *'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Password, {
              modelValue: _ctx.pwd,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pwd = $event)),
              class: _normalizeClass({ 'p-invalid' : _ctx.pwdErrors?.length > 0 }),
              feedback: false,
              toggleMask: ""
            }, null, 8, ["modelValue", "class"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pwdErrors, (e) => {
          return (_openBlock(), _createElementBlock("p", {
            key: `pwd_${e}`,
            class: "p-error"
          }, _toDisplayString(_ctx.$t(e)), 1))
        }), 128)),
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('user.confirm_password') + ' *',
          class: "p-mt-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Password, {
              modelValue: _ctx.cpwd,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.cpwd = $event)),
              class: _normalizeClass({ 'p-invalid' : _ctx.cpwdErrors?.length > 0 }),
              feedback: false,
              toggleMask: ""
            }, null, 8, ["modelValue", "class"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cpwdErrors, (e) => {
          return (_openBlock(), _createElementBlock("p", {
            key: `cpwd_${e}`,
            class: "p-error"
          }, _toDisplayString(_ctx.$t(e)), 1))
        }), 128))
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default", { value: _ctx.value })
  ], 40, _hoisted_1))
}